<template>
  <div>
    <template v-if="loading">
      <loading-spinner />
    </template>
    <template v-else>
      <h4>Smart Import settings:</h4>
      <p>
        Filename <i>must</i> be correctly structured (see examples). You can
        leave out some of the parameters, but MUST include the
        <code>_</code> character.
      </p>
      <p>
        All text is matched case-insensitive.
      </p>
      <p>
        Manufacturer and Device names: Spaces are ignored, and we only check the
        following symbols: <code>+</code> <code>-</code> <code> &</code>
        <code>(</code>
        <code>)</code>
      </p>
      <p>
        Template Format:
        <code
          >DEVICETYPE_MANUFACTURER_DEVICENAME_TEMPLATENAME_CATEGORIES_OPTIONS</code
        >
      </p>
      <div v-for="(value, key) in smartValues" :key="key">
        <b>{{ key }}</b>
        <span v-if="!value"> = Type in the name</span>
        <ul>
          <li v-for="(value2, key2) in value" :key="key + key2">
            <code>{{ key2 }}</code> = {{ value2 }}
          </li>
        </ul>
      </div>
      <h4>Examples:</h4>
      <ul>
        <li>
          <code>__iPhone 6_FRONT__CO,H.svg</code> = iPhone 6, Front, Cut Only,
          Hidden (no manufacturer or device type filter applied when searching)
        </li>
        <li>
          <code>P_AppLe_iPhone 6_FRONT_NO,MA_CO,H.svg</code> = iPhone 6, Front,
          Normal, Magic, Cut Only, Hidden
        </li>
        <li>
          <code>T_AppLe_iPhone 6_FRONT_NO,MA_CO,H.svg</code> = No device, Front,
          Normal, Magic, Cut Only, Hidden (unable to find iPhone 6 that is a
          Tablet)
        </li>
      </ul>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  components: {
    LoadingSpinner,
  },
  computed: {
    ...mapGetters('smartimport', {
      loading: 'loading',
      smartValues: 'getSmartValues',
    }),
  },
};
</script>
